import { render, staticRenderFns } from "./FollowButton.vue?vue&type=template&id=8a8e6866&scoped=true"
import script from "./FollowButton.vue?vue&type=script&lang=ts"
export * from "./FollowButton.vue?vue&type=script&lang=ts"
import style0 from "./FollowButton.vue?vue&type=style&index=0&id=8a8e6866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8e6866",
  null
  
)

export default component.exports